import { FC } from 'react';
import { TaskStatus } from '@weave/schema-gen-ts/dist/schemas/task-center/shared/v1/enums.pb';
import { CheckListFilterSelector } from '@frontend/analytics-shared';
import { useTranslation } from '@frontend/i18n';
import { FilterTraySection } from '../filter-tray-section/filter-tray-section';
import { useTaskStatusFilterData } from './use-task-status-filter-data';

export const TaskStatusFilterTray: FC<{ disabled?: boolean; trackingIdBase?: string; showClear?: boolean }> = ({
  disabled,
  trackingIdBase,
  showClear,
}) => {
  const { value: selectedValues, taskStatusOptions, isLoading, onChange } = useTaskStatusFilterData();
  const { t } = useTranslation('call-intelligence');
  const isDisabled = disabled || isLoading;

  return (
    <FilterTraySection label={t('Status')} disableClear={isDisabled} showClear={showClear} onClear={() => onChange([])}>
      <CheckListFilterSelector<TaskStatus>
        label={t('Status')}
        onChange={onChange}
        options={taskStatusOptions}
        showLabel={false}
        trackingIdBase={trackingIdBase}
        value={selectedValues}
        disabled={isDisabled}
      />
    </FilterTraySection>
  );
};
